import React from "react";
import { useTranslation } from "react-i18next";
import { IoPlayForwardCircle } from "react-icons/io5";
import DetailsHeaderFirstRow from "./DetailsHeaderFirstRow";
import DetailsHeaderSecondRow from "./DetailsHeaderSecondRow";
import DetailsMobileHeaderFirstRow from "./MobileDetailsHeaderFirstRow";
import { Col, Row } from "antd";
import MobileSubjectUserDetails from "./MobileSubjectUserDetails";
type Props = {};

const SubjectScreeningHeaderFirstColumn = (props: Props) => {
  const { t } = useTranslation();

  return (
    <div className="details_first_column">
      <div className="details_first_column_container">
        <DetailsHeaderFirstRow />
        <DetailsMobileHeaderFirstRow />
      </div>
      <DetailsHeaderSecondRow />
    </div>
  );
};

export default SubjectScreeningHeaderFirstColumn;
